// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".view-article .button-all-news{--tw-text-opacity:1;color:#0090d4;color:rgba(0,144,212,var(--tw-text-opacity))}.view-article .button-all-news:hover{--tw-text-opacity:1;color:#1c75ba;color:rgba(28,117,186,var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
